import React, { useState } from "react";
import DropdownField from "../../components/DropdownField";

import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";

function StoryComponent({ disabled }: { disabled: boolean }) {
    const [selectValue1, setSelectValue1] = useState<string>("");
    const [selectValue2, setSelectValue2] = useState<string>("");
    const [selectValue3, setSelectValue3] = useState<string>("");
    const [selectValue4, setSelectValue4] = useState<string>("");
    const [selectValue5, setSelectValue5] = useState<string>("");
    const [selectValue6, setSelectValue6] = useState<string>("");

    return (
        <VStack gap="1" style={{ padding: 10, alignSelf: "stretch" }}>
            <DropdownField
                style={{ alignSelf: "stretch" }}
                value={selectValue1}
                left="training"
                items={[
                    {
                        label: "Jimi Hendrix",
                        value: "jh",
                    },
                    {
                        label: "Michel Jackson",
                        value: "mj",
                    },
                    {
                        label: "Kurt Cobain",
                        value: "kc",
                        icon: "mission",
                    },
                ]}
                onSelect={setSelectValue1}
                disabled={disabled}
            />
            <DropdownField
                style={{ alignSelf: "stretch" }}
                value={selectValue2}
                left="holiday"
                items={[
                    {
                        label: "Jimi Hendrix",
                        value: "jh",
                    },
                    {
                        label: "Michel Jackson",
                        value: "mj",
                    },
                    {
                        label: "Bob Dylan qui a un nom super long pour tester les affichages sur deux lignes et encore plus long",
                        value: "bd",
                    },
                    {
                        label: "Kurt Cobain",
                        value: "kc",
                        icon: "mission",
                    },
                    {
                        label: "Stevie Wonder",
                        value: "sw",
                    },
                    {
                        label: "Marvin Gaye",
                        value: "mg",
                    },
                    {
                        label: "Eric Clapton",
                        value: "ec",
                    },
                ]}
                label="Musician"
                onSelect={setSelectValue2}
                numberOfLines={2}
                disabled={disabled}
            />
            <DropdownField
                style={{ alignSelf: "stretch" }}
                value={selectValue3}
                left="work"
                items={[
                    {
                        label: "Slash",
                        value: "sl",
                    },
                    {
                        label: "Mark Knopfler",
                        value: "mk",
                    },
                    {
                        label: "Carlos Santana",
                        value: "cs",
                    },
                    {
                        label: "Eddie Van Halen",
                        value: "evh",
                    },
                    {
                        label: "Chuck Berry",
                        value: "cb",
                    },
                    {
                        label: "John Petrucci",
                        value: "jp",
                    },
                    {
                        label: "Brian May",
                        value: "bm",
                    },
                ]}
                label="Guitarist"
                onSelect={setSelectValue3}
                disabled={disabled}
            />
            <DropdownField
                style={{ alignSelf: "stretch" }}
                value={selectValue4}
                items={[
                    {
                        label: "PRS - Custom 24",
                        value: "prs",
                    },
                    {
                        label: "Les Paul",
                        value: "lp",
                    },
                    {
                        label: "EPS - Horizon II",
                        value: "eps",
                    },
                    {
                        label: "Stratocaster",
                        value: "st",
                    },
                    {
                        label: "Telecaster",
                        value: "tely",
                    },
                    {
                        label: "Music man - John Petrucci",
                        value: "jp",
                    },
                    {
                        label: "Ibanez - RG5120",
                        value: "ib",
                    },
                ]}
                label="Guitar"
                onSelect={setSelectValue4}
                disabled={disabled}
            />

            <DropdownField
                style={{ alignSelf: "stretch" }}
                value={selectValue5}
                items={[
                    {
                        label: "The Shape of Punk to Come: A Chimerical Bombination in 12 Bursts - Refused (1998) - Suède",
                        value: "001",
                    },
                    {
                        label: "The Rise and Fall of Ziggy Stardust and the Spiders from Mars - David Bowie (1971) - Royaume-Uni",
                        value: "002",
                    },
                    {
                        label: "Lift Your Skinny Fists Like Antennas to Heaven - Godspeed You! Black Emperor (2000) - Canada - Lift Your Skinny Fists Like Antennas to Heaven - Godspeed You! Black Emperor (2000) - Canada ",
                        value: "003",
                    },
                ]}
                label="Album name"
                onSelect={setSelectValue5}
                disabled={disabled}
            />
            <DropdownField
                style={{ alignSelf: "stretch" }}
                value={selectValue6}
                withScreenActionsPadding={false}
                items={[
                    {
                        label: "PRS - Custom 24 - 1",
                        value: "prs",
                    },
                    {
                        label: "Les Paul - 1",
                        value: "lp",
                    },
                    {
                        label: "EPS - Horizon II - 1",
                        value: "eps",
                    },
                    {
                        label: "Stratocaster - 1",
                        value: "st",
                    },
                    {
                        label: "Telecaster - 1",
                        value: "tely",
                    },
                    {
                        label: "Music man - John Petrucci - 1",
                        value: "jp",
                    },
                    {
                        label: "Ibanez - RG5120 - 1",
                        value: "ib",
                    },
                    {
                        label: "PRS - Custom 24 - 2",
                        value: "prs",
                    },
                    {
                        label: "Les Paul - 2",
                        value: "lp",
                    },
                    {
                        label: "EPS - Horizon II - 2",
                        value: "eps",
                    },
                    {
                        label: "Stratocaster - 2",
                        value: "st",
                    },
                    {
                        label: "Telecaster - 2",
                        value: "tely",
                    },
                    {
                        label: "Music man - John Petrucci - 2",
                        value: "jp",
                    },
                    {
                        label: "Ibanez - RG5120 - 2",
                        value: "ib",
                    },
                    {
                        label: "PRS - Custom 24 - 3",
                        value: "prs",
                    },
                    {
                        label: "Les Paul - 3",
                        value: "lp",
                    },
                    {
                        label: "EPS - Horizon II - 3",
                        value: "eps",
                    },
                    {
                        label: "Stratocaster - 3",
                        value: "st",
                    },
                    {
                        label: "Telecaster - 3",
                        value: "tely",
                    },
                    {
                        label: "Music man - John Petrucci - 3",
                        value: "jp",
                    },
                    {
                        label: "Ibanez - RG5120 - 3",
                        value: "ib",
                    },
                ]}
                label="Album name"
                onSelect={setSelectValue6}
                disabled={disabled}
            />
        </VStack>
    );
}

const meta = {
    title: "Fields/Dropdown",
    component: StoryComponent,
    decorators: [],
    argTypes: {
        disabled: {
            control: {
                type: "boolean",
            },
        },
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        disabled: false,
    },
};

export const Disabled: Story = {
    args: {
        disabled: true,
    },
};
